import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MwcAvatarModule } from 'mwc/avatar';
import { MwcIconModule } from 'mwc/icon';
import { MwcToolTipModule } from 'mwc/tooltip';
import { MwcContributorsListComponent } from './contributors-list.component';

@NgModule({
  imports: [CommonModule, RouterModule, HttpClientModule, MwcIconModule, MwcAvatarModule, MwcToolTipModule],
  declarations: [MwcContributorsListComponent],
  exports: [MwcContributorsListComponent]
})
export class MwcContributorsListModule {}
